__turbopack_context__.v({
  "base": "OR7JFq_base",
  "columns": "OR7JFq_columns",
  "default": "OR7JFq_default",
  "dropcap": "OR7JFq_dropcap",
  "emphasized": "OR7JFq_emphasized",
});
